import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import category from 'src/types/category';

import { sendEventClick } from 'src/api/tracker';

import 'src/components/DesktopTabs.scss';

const DesktopTabs = ({ categories, activateTab }) => {
  const activateTabMemo = useCallback(activateTab, [activateTab]);

  return (
    <ul data-test="list-advices_category">
      {categories.map(({ id, name, active }, index) => {
        return (
          <li
            data-test="list-item-advices_category"
            key={id}
            styleName={classNames({
              category: true,
              'category--active': active,
            })}
          >
            <button
              data-test={`button-${name}`}
              onClick={() => {
                if (!active) {
                  activateTabMemo(id);
                  sendEventClick(`advices_category_${id}`, index);
                }
              }}
              styleName="category__button"
              type="button"
            >
              {name}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

DesktopTabs.propTypes = {
  activateTab: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(category)).isRequired,
};

export default DesktopTabs;
